import React from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorScreen = () => {
    const navigate = useNavigate();

    return (
        <main className="min-h-screen flex items-center justify-center bg-[#f6ebf3]">
            <div className="max-w-screen-xl px-6 text-center">
                <div className="flex flex-col items-center justify-center">
                    <div className="overflow-hidden rounded-3xl shadow-lg mb-10">
                        <img
                            className="w-80 md:w-96 object-contain"
                            src="/assets/error.gif"   
                            alt="Erreur"
                        />
                    </div>

                    <h1 className="text-4xl font-bold text-paragaia mb-4 poppins">Oups ! Une erreur est survenue</h1>
                    <p className="text-gray-600 text-lg mb-8 poppins">
                        Désolé, la page que vous recherchez est introuvable.
                    </p>

                    <button
                        className="bg-paragaia hover:bg-paragaiaLight text-white px-8 py-3 rounded-full text-lg transition duration-300 poppins"
                        onClick={() => navigate('/')}
                    >
                        Retour à l'accueil
                    </button>
                </div>
            </div>
        </main>
    );
};

export default ErrorScreen;
